
import { NotificationFilter } from '@/entities/Notification/NotificationFilter';
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
@Component({
  components: {},
})
class NotificationFilterEditPane extends Vue {
  @Prop() selectedFilterItem!: NotificationFilter;
  private localSelectedFilter = NotificationFilter.createEmpty();
  private mounted() {
    if(!!this.selectedFilterItem) {
      this.localSelectedFilter = Object.assign({}, this.selectedFilterItem);
    }
  }
  private EditFilter() {
    this.$emit('edit-filter-item', this.localSelectedFilter.Id);
  }
}
export default toNative(NotificationFilterEditPane);
